import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
// import { hmrBootstrap } from './hmr';

if (environment.production) {
    enableProdMode();
}

console.log(`欢迎使用SRM! 当前主线版本: ${environment.appVersion}`);

const bootstrap = (): Promise<any> => {
    return platformBrowserDynamic().bootstrapModule(AppModule)
        .catch(err => console.log(err));
};
bootstrap();

// if (environment.hmr) {
//     if (module['hot']) {
//         hmrBootstrap(module, bootstrap);
//     } else {
//         console.error('HMR没有启用，确保 ng server 命令加上 --hmr 标记');
//     }
// } else {
//     bootstrap();
// }



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/main.ts